export const LINE_TOOL_GROUPS_THROTTLE = 100;
export const DRAWINGS_SAVE_THROTTLE = 500;
export const UPSTOX_LAYOUT_DEFAULT_CHART_CONTENT = {
  name: 'Upstox Layout',
  layout: 's',
  charts: [
    {
      panes: [
        {
          sources: [
            {
              type: 'MainSeries',
              id: '_seriesId',
              state: {
                style: 1,
                lineStyle: {},
                symbol: 'NSE_INDEX_TOKEN_Nifty_50:Nifty 50',
                shortName: 'Nifty 50',
                timeframe: '',
                interval: '3',
              },
            },
          ],
          mainSourceId: '_seriesId',
          leftAxisesState: [],
          rightAxisesState: [
            {
              state: {
                id: 'zYYKZlMhUv5z',
                m_priceRange: null,
                m_isAutoScale: true,
                m_isPercentage: false,
                m_isIndexedTo100: false,
                m_isLog: false,
                m_isLockScale: false,
                m_isInverted: false,
              },
              sources: ['_seriesId'],
            },
          ],
        },
      ],
      timeScale: {},
    },
  ],
};
